module.exports = __webpack_public_path__ + "static/media/bgImage@1x.982422fa.jpg";